import { MakeCall } from './createMakeCall';
import { Message } from 'ha/services/apiV2/types/Conversation';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<Message>(
    'GET',
    `${APIV2_URL}/conversation/${conversationId}/messages`,
  );
